import { defineStore } from 'pinia'
import { ref } from 'vue'

export type NotificationType = 'success' | 'error' | 'info' | 'warning'

export interface Notification {
    message: string
    type: NotificationType
    id: number
    duration?: number
}

export const useNotificationStore = defineStore('notification', () => {
    const notifications = ref<Notification[]>([])
    let nextId = 1

    const notify = (message: string, type: NotificationType = 'success', duration = 4000) => {
        const id = nextId++
        notifications.value.push({ message, type, id, duration })

        if (duration > 0) {
            setTimeout(() => {
                remove(id)
            }, duration)
        }
        return id
    }

    const showSuccess = (message: string, duration = 4000) => notify(message, 'success', duration)
    const showError = (message: string, duration = 5000) => notify(message, 'error', duration)
    const showWarning = (message: string, duration = 4500) => notify(message, 'warning', duration)
    const showInfo = (message: string, duration = 4000) => notify(message, 'info', duration)

    const remove = (id: number) => {
        const index = notifications.value.findIndex(n => n.id === id)
        if (index !== -1) {
            notifications.value.splice(index, 1)
        }
    }

    return {
        notifications,
        notify,
        showSuccess,
        showError,
        showWarning,
        showInfo,
        remove
    }
})
